<template>
  <div id="app" class="kudu-app">
    <router-view></router-view>
  </div>
</template>

<script>
import "@/assets/css/common.css";
import router from "./router";

export default {
  name: "App",

  created() {
    // make timeout callback debounce
    this.onTokenTimeoutDebounce = this.$lodash.debounce(
      this.onTokenTimeout,
      1000
    );
    this.$bus.$on("token-timeout", this.onTokenTimeoutDebounce);
  },

  methods: {
    onTokenTimeout: function(event) {

      this.$bus.$emit("cancel-all-current-request", "token timeout");

      this.$store.commit(this.$types.LOGOUT);

      this.$Notice.warning({
        title: "Warning",
        desc: "Session expired"
      });

      // 只有在当前路由不是登录页面才跳转
      router.currentRoute.path !== "login" &&
        router.replace({
          path: "login",
          query: { redirect: router.currentRoute.path }
        });
    }
  }
};
</script>

<style>
html,
body.login-page {
  height: 100%;
  width: 100%;
}
body {
  background-color: #f5f7f9;
}
.scrollable{
  overflow: auto;
}
.scrollable.scroll-hidden{
  overflow: hidden;
}
.scrollable:hover{
  overflow: auto;
}
.scrollable::-webkit-scrollbar {
  -webkit-appearance: none;
}

.scrollable::-webkit-scrollbar:vertical {
  width: 5px;
}
.scrollable::-webkit-scrollbar:horizontal {
  height: 5px;
}

.scrollable::-webkit-scrollbar-button:increment, .scrollable::-webkit-scrollbar-button {
  display: none;
}

.scrollable::-webkit-scrollbar-thumb {
  background-color: #c7c7ec;
  border-radius: 3px;
}

.scrollable::-webkit-scrollbar-track {
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue